import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 py-8" }
const _hoisted_2 = { class: "flex flex-row justify-center items-center gap-4 w-full" }
const _hoisted_3 = ["disabled"]

import { watch } from "vue";
import { storeToRefs } from "pinia";
import NewModal from "@/components/atoms/NewModal.vue";
import TextField from "@/components/atoms/TextField.vue";

import useDividendsStore from "@/stores/dividends";

import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDividendModal',
  props: {
  visible: {
    type: Boolean,
    required: false,
    default: false,
  },
  dividendData: {
    type: Object,
    required: false,
  },
},
  emits: ["close", "refetch"],
  setup(__props, { emit }) {

const props = __props;




const store = useDividendsStore();
const { dividendForm, updateDividendResponse } = storeToRefs(store);

watch(props, () => {
  if (props.visible && props.dividendData) {
    store.setDividendForm(props.dividendData);
  }
});

watch(updateDividendResponse, () => {
  if (updateDividendResponse?.value?.success) {
    Swal.fire("¡Listo!", "Código modificado exitosamente.", "success");
  } else {
    Swal.fire("¡Error!", "Oops, tuvimos un error!", "error");
  }
  emit("refetch");
  emit("close");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewModal, {
    title: "Editar dividendo",
    visible: __props.visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = () => _ctx.$emit('close'))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('close')),
          type: "button",
          class: "flex flex-row items-center rounded-full px-4 py-2 bg-gray-400 transition text-sm shadow text-white"
        }, " Cancelar "),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = () => _unref(store).updateDividend(__props.dividendData.id)),
          disabled: !_unref(dividendForm).code,
          class: "btn"
        }, " Guardar ", 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TextField, {
          type: "text",
          name: "dividend_number",
          label: "Número de dividendo",
          placeholder: "Ingrese número de dividendo",
          model: _unref(dividendForm).code,
          "onUpdate:model": _cache[0] || (_cache[0] = 
          (value) => {
            if (_unref(dividendForm)) _unref(dividendForm).code = value ?? '';
          }
        )
        }, null, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})